import apiConfig from "../../../config/api";

let apiUriMovilidad = `${apiConfig.baseUriApiMovilidad}/movilidad/PlanMov`;
let apiUriContenidos = `${apiConfig.baseUriApiMovilidad}/movilidad/Contenido`;
let apiUriAccidentes = `${apiConfig.baseUriApiMovilidad}/movilidad/Accidente`;
let apiUriEncuesta = `${apiConfig.baseUriApiMovilidad}/movilidad/Encuesta`;

const config = {
  apiUriMovilidad,
  apiUriContenidos,
  apiUriAccidentes,
  apiUriEncuesta,
};

export default config;

